import { NoticeStatusType } from './NoticeStatusType';

export const NoticeStatusTypeOptions = [
    {
        id: NoticeStatusType.NA,
        name: 'Not Applicable',
        color: 'gray',
    },
    {
        id: NoticeStatusType.Pending,
        name: 'Pending File Generation',
        color: 'orange',
    },
    {
        id: NoticeStatusType.Generated,
        name: 'Notice created - File Uploaded or Generated',
        color: 'green',
    },
    {
        id: NoticeStatusType.Emailed,
        name: 'Emailed',
        color: 'green',
    },
    {
        id: NoticeStatusType.Error,
        name: 'Error',
        color: 'red',
    },
];
